/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AcknowledgePositionRequest } from '@coin/shared/core/util-models-v2';
import { CommentModel } from '@coin/shared/core/util-models-v2';
import { CreateJobDescription } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequest } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequestComment } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequestDraft } from '@coin/shared/core/util-models-v2';
import { CreatePositionRequestPlan } from '@coin/shared/core/util-models-v2';
import { Dashboard } from '@coin/shared/core/util-models-v2';
import { EmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { EnhanceJobDescription } from '@coin/shared/core/util-models-v2';
import { FieldValues } from '@coin/shared/core/util-models-v2';
import { GenerateJobDescription } from '@coin/shared/core/util-models-v2';
import { GeneratedJobDescription } from '@coin/shared/core/util-models-v2';
import { HeadcountApprovalDashboard } from '@coin/shared/core/util-models-v2';
import { HeadcountApprovalPositionSurveyData } from '@coin/shared/core/util-models-v2';
import { JobAd } from '@coin/shared/core/util-models-v2';
import { JobDescription } from '@coin/shared/core/util-models-v2';
import { MercerJobCodeResponse } from '@coin/shared/core/util-models-v2';
import { PageOfCluster } from '@coin/shared/core/util-models-v2';
import { PageOfClusterNode } from '@coin/shared/core/util-models-v2';
import { PageOfCountryClusterNode } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfHeadcountApprovalOrgCode } from '@coin/shared/core/util-models-v2';
import { PageOfMinimalJobDescription } from '@coin/shared/core/util-models-v2';
import { PageOfPositionRequest } from '@coin/shared/core/util-models-v2';
import { PageOfPositionRequestDraft } from '@coin/shared/core/util-models-v2';
import { PageOfReplacementEmployee } from '@coin/shared/core/util-models-v2';
import { PositionRequest } from '@coin/shared/core/util-models-v2';
import { PositionRequestDraft } from '@coin/shared/core/util-models-v2';
import { PositionRequestPlanDashboard } from '@coin/shared/core/util-models-v2';
import { ReferenceEmployee } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransferPositionRequest } from '@coin/shared/core/util-models-v2';
import { UpdateJobDescription } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequest } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestDraft } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestPlan } from '@coin/shared/core/util-models-v2';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface AcknowledgePositionRequestsParams {
  /** The unqique id of the position request to acknowledge an approval of. */
  id: string;
  /** The unique id of the approval to acknowledge. */
  approvalId: string;
  /** The date of the last refresh of the requester to be able to assure the request has not been updated in the meantime. */
  ifUnmodifiedSince?: string;
  /** The model data to acknowledge the approval with. */
  acknowledgePositionRequest?: AcknowledgePositionRequest;
}

export interface CreateJobDescriptionsParams {
  /** The model data to create the job description with. */
  createJobDescription?: CreateJobDescription;
}

export interface CreatePositionRequestCommentsParams {
  /** The unique id of the existing position request. */
  positionRequestId: string;
  /** The model data to create the comment with. */
  createPositionRequestComment?: CreatePositionRequestComment;
}

export interface CreatePositionRequestDraftsParams {
  /** The model data to create the position request draft with. */
  createPositionRequestDraft?: CreatePositionRequestDraft;
}

export interface CreatePositionRequestPlanParams {
  /** The model data to create the position request plan with. */
  createPositionRequestPlan?: CreatePositionRequestPlan;
}

export interface CreatePositionRequestsParams {
  /** The model data to create the position request with. */
  createPositionRequest?: CreatePositionRequest;
}

export interface DeletePositionRequestDraftsParams {
  /** The unique id of the position request draft to delete. */
  id: string;
}

export interface DeletePositionRequestPlanParams {
  /** The unique id of the position request plan to delete. */
  id: string;
}

export interface DeletePositionRequestsParams {
  /** The unique id of the position request to delete. */
  id: string;
}

export interface EndJobDescriptionSessionParams {
  sessionId: string;
}

export interface EnhanceJobDescriptionParams {
  enhanceJobDescription?: EnhanceJobDescription;
}

export interface ExportPositionRequestsParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
  /** The state of the position request export. */
  exportState?: 'Open' | 'Done';
  /** The filename of the position request export. */
  filename?: string;
}

export interface GenerateJobDescriptionParams {
  generateJobDescription?: GenerateJobDescription;
}

export interface GetByIdJobAdsParams {
  /** The ID of the job ad to retrieve. */
  id: string;
}

export interface GetByIdJobDescriptionsParams {
  /** The ID of the job description to retrieve. */
  id: string;
}

export interface GetByIdPositionRequestsParams {
  /** The unique id of the position request. */
  id: string;
}

export interface GetHiringManagersEmployeeMasterDataParams {
  search?: string;
  page?: number;
  size?: number;
}

export interface GetOrganisationHiringManagerOrganisationsParams {
  orgCode: string;
}

export interface GetPositionRequestPlanDashboardParams {
  /** The request type of the position request. */
  requestType?: Array<'Addition' | 'Replacement'>;
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: Array<'BestCost' | 'HighCost'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: Array<'Head' | 'Employee'>;
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface GetPositionSurveyDataHeadcountApprovalParams {
  /** The organisation\&#39;s code of a position to request survey data for. */
  orgCode: string;
  /** The ISO2 country code of a position to request survey data for. */
  countryIsoAlpha2?: string;
  /** The derived position class of a position to request survey data for. */
  positionClass?: number;
  /** The mercer job code to get matching position survey data for. */
  mercerJobCodeResponse?: MercerJobCodeResponse;
}

export interface GetStatesDashboardPositionRequestsParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams {
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface PagePositionRequestPlanBusinessAreasParams {
  page?: number;
  size?: number;
  /** The search text to compare business areas with. */
  search?: string;
}

export interface PagePositionRequestPlanFieldValuesParams {
  page?: number;
  size?: number;
  /** The request type of the position request. */
  requestType?: string;
  /** The organization codes of the position request. */
  orgCode?: string;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: string;
  /** The requester gids of the position request. */
  hiringManagerGid?: string;
  /** The position classes of the position request. */
  positionClass?: string;
  /** The organization levels of the position request. */
  orgLevel?: string;
  /** The position type of the position request. */
  positionType?: string;
  /** The query type of the position request. */
  workforceType?: string;
  /** WorkTimeType of the employee. */
  workTimeType?: string;
  /** The property for which to return field-values. */
  targetProperty?:
    | 'RequestType'
    | 'CountryGeoClusterNodeId'
    | 'NMinusOneLevelClusterNodeId'
    | 'OrgCode'
    | 'LocationType'
    | 'HiringManagerGid'
    | 'PositionClass'
    | 'OrgLevel'
    | 'PositionType'
    | 'WorkforceType'
    | 'WorkTimeType'
    | 'AreCode'
    | 'DepthStructure'
    | 'CostCenter'
    | 'Country'
    | 'Region';
}

export interface PagePositionRequestPlanNMinusOneLevelsParams {
  /** The business-area of which to get n-minus-one-levels for. */
  businessAreaId: string;
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface PagePositionRequestPlanOrgCodesParams {
  /** The search text to compare orgcodes with. */
  search?: string;
  /** The search text orgcodes have to start with. */
  orgCodeStartsWith?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface PagePositionRequestPlanReplacementEmployeesParams {
  /** The search text to filter directs with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface PagePositionRequestPlansParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  /** The request type of the position request. */
  requestType?: Array<'Addition' | 'Replacement'>;
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: Array<'BestCost' | 'HighCost'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: Array<'Head' | 'Employee'>;
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface PagePositionRequestReplacementEmployeesParams {
  /** The search text to filter directs with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface QueryBusinessAreaNMinusOneLevelsBusinessAreasParams {
  businessAreaId: string;
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface QueryEmployeeMasterDataEmployeeMasterDataParams {
  employeeId: string;
}

export interface QueryFieldValuesPositionRequestsParams {
  /** The target property of the position request field value. */
  targetProperty:
    | 'State'
    | 'PendingApprovalStepName'
    | 'RequestType'
    | 'CountryGeoClusterNodeId'
    | 'NMinusOneLevelClusterNodeId'
    | 'OrgCode'
    | 'LocationType'
    | 'HiringManagerGid'
    | 'PositionClass'
    | 'OrgLevel'
    | 'PositionType'
    | 'WorkforceType'
    | 'WorkTimeType'
    | 'ReferenceNumber'
    | 'AreCode'
    | 'DepthStructure'
    | 'CostCenter'
    | 'Country'
    | 'Region';
  pagingPage?: number;
  pagingSize?: number;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?:
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed';
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node id of the position request. */
  countryGeoClusterNodeId?: string;
  /** The n-1 level cluster node id of the position request. */
  nMinusOneLevelClusterNodeId?: string;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The requester gid of the position request. */
  hiringManagerGid?: string;
  /** The position class of the position request. */
  positionClass?: number;
  /** The organization code of the position request. */
  orgCode?: string;
  /** The organization level of the position request. */
  orgLevel?: number;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The workforce type of the position request. */
  workforceType?:
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal';
  /** WorkTimeType of the employee. */
  workTimeType?: 'Either' | 'FullTime' | 'PartTime';
  /** Reference number in COIN. */
  referenceNumber?: number;
  /** Legal entity / are code of the position request. */
  areCode?: string;
  /** Depth Structure of the position request. */
  depthStructure?: string;
  /** Cost Center of the position request. */
  costCenter?: string;
  /** Any one of the countries of the position request. */
  country?: string;
  /** Any one of the regions of the position request. */
  region?: string;
}

export interface QueryJobDescriptionsParams {
  /** The organisational code. */
  orgCode: string;
  /** The unique id of the job code (from Mercer). */
  jobCodeId?: string;
  /** The search text to search the title */
  search?: string;
  page?: number;
  size?: number;
}

export interface QueryOrgCodesHeadcountApprovalParams {
  /** The search text to compare orgcodes with. */
  search?: string;
  /** The search text orgcodes have to start with. */
  orgCodeStartsWith?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface QueryPositionRequestCommentsParams {
  /** The unique id of the position request to return comments of. */
  positionRequestId: string;
}

export interface QueryPositionRequestsParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface QueryReferenceEmployeesEmployeeMasterDataParams {
  orgCode: string;
  search?: string;
}

export interface QueryRegionCountriesCountriesParams {
  /** The search text to compare business areas with. */
  search?: string;
  regionIds?: Array<string>;
  page?: number;
  size?: number;
}

export interface QueryRegionsRegionsParams {
  /** The search text to compare regions with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface TransferPositionRequestParams {
  /** The unique id of the position request to transfer. */
  id: string;
  /** The model data containing the target organization and optional new start date. */
  transferPositionRequest?: TransferPositionRequest;
}

export interface UpdateJobDescriptionsParams {
  /** The ID of the job description to update. */
  id: string;
  /** The updated job description data. */
  updateJobDescription?: UpdateJobDescription;
}

export interface UpdatePositionRequestDraftsParams {
  /** The unique id of the position request draft to update. */
  id: string;
  /** The model data to update the existing position request draft with. */
  updatePositionRequestDraft?: UpdatePositionRequestDraft;
}

export interface UpdatePositionRequestPlanParams {
  /** The unique id of the position request plan to update. */
  id: string;
  /** The model data to update the existing position request plan with. */
  updatePositionRequestPlan?: UpdatePositionRequestPlan;
}

export interface UpdatePositionRequestsParams {
  /** The unique id of the position request to update (or the unique id of the draft to create the position request from). */
  id: string;
  /** The model data to update an existing position request with (or the model data to create a new position request from a position request draft). */
  updatePositionRequest?: UpdatePositionRequest;
}

export interface VetoPositionRequestsParams {
  /** The unique id of the position request to veto. */
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeadcountApprovalCustomerService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Acknowledges a specific, existing approval of an existing position request by their unique ids.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acknowledgePositionRequests(
    requestParameters?: AcknowledgePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequest>;
  public acknowledgePositionRequests(
    requestParameters?: AcknowledgePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequest>>;
  public acknowledgePositionRequests(
    requestParameters?: AcknowledgePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequest>>;
  public acknowledgePositionRequests(
    requestParameters?: AcknowledgePositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling acknowledgePositionRequests.');
    }
    const approvalId = requestParameters?.approvalId;
    if (approvalId === null || approvalId === undefined) {
      throw new Error('Required parameter approvalId was null or undefined when calling acknowledgePositionRequests.');
    }
    const ifUnmodifiedSince = requestParameters?.ifUnmodifiedSince;
    const acknowledgePositionRequest = requestParameters?.acknowledgePositionRequest;

    let localVarHeaders = this.defaultHeaders;
    if (ifUnmodifiedSince !== undefined && ifUnmodifiedSince !== null) {
      localVarHeaders = localVarHeaders.set('If-Unmodified-Since', String(ifUnmodifiedSince));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/acknowledge`;
    return this.httpClient.request<PositionRequest>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: acknowledgePositionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates a new job description.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createJobDescriptions(
    requestParameters?: CreateJobDescriptionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<JobDescription>;
  public createJobDescriptions(
    requestParameters?: CreateJobDescriptionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<JobDescription>>;
  public createJobDescriptions(
    requestParameters?: CreateJobDescriptionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<JobDescription>>;
  public createJobDescriptions(
    requestParameters?: CreateJobDescriptionsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createJobDescription = requestParameters?.createJobDescription;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-descriptions`;
    return this.httpClient.request<JobDescription>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createJobDescription,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates a new comment for an existing position request.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequestComments(
    requestParameters?: CreatePositionRequestCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<CommentModel>;
  public createPositionRequestComments(
    requestParameters?: CreatePositionRequestCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<CommentModel>>;
  public createPositionRequestComments(
    requestParameters?: CreatePositionRequestCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<CommentModel>>;
  public createPositionRequestComments(
    requestParameters?: CreatePositionRequestCommentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    if (positionRequestId === null || positionRequestId === undefined) {
      throw new Error(
        'Required parameter positionRequestId was null or undefined when calling createPositionRequestComments.'
      );
    }
    const createPositionRequestComment = requestParameters?.createPositionRequestComment;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`;
    return this.httpClient.request<CommentModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createPositionRequestComment,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates a new position request draft.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequestDrafts(
    requestParameters?: CreatePositionRequestDraftsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequestDraft>;
  public createPositionRequestDrafts(
    requestParameters?: CreatePositionRequestDraftsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequestDraft>>;
  public createPositionRequestDrafts(
    requestParameters?: CreatePositionRequestDraftsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequestDraft>>;
  public createPositionRequestDrafts(
    requestParameters?: CreatePositionRequestDraftsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createPositionRequestDraft = requestParameters?.createPositionRequestDraft;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/drafts`;
    return this.httpClient.request<PositionRequestDraft>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createPositionRequestDraft,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates a new position request plan.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequestPlan(
    requestParameters?: CreatePositionRequestPlanParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequestDraft>;
  public createPositionRequestPlan(
    requestParameters?: CreatePositionRequestPlanParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequestDraft>>;
  public createPositionRequestPlan(
    requestParameters?: CreatePositionRequestPlanParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequestDraft>>;
  public createPositionRequestPlan(
    requestParameters?: CreatePositionRequestPlanParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createPositionRequestPlan = requestParameters?.createPositionRequestPlan;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plans`;
    return this.httpClient.request<PositionRequestDraft>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createPositionRequestPlan,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates a new position request.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequests(
    requestParameters?: CreatePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequest>;
  public createPositionRequests(
    requestParameters?: CreatePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequest>>;
  public createPositionRequests(
    requestParameters?: CreatePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequest>>;
  public createPositionRequests(
    requestParameters?: CreatePositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createPositionRequest = requestParameters?.createPositionRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests`;
    return this.httpClient.request<PositionRequest>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createPositionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Deletes an existing position request draft by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequestDrafts(
    requestParameters?: DeletePositionRequestDraftsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePositionRequestDrafts(
    requestParameters?: DeletePositionRequestDraftsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePositionRequestDrafts(
    requestParameters?: DeletePositionRequestDraftsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePositionRequestDrafts(
    requestParameters?: DeletePositionRequestDraftsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePositionRequestDrafts.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/drafts/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Deletes an existing position request plan by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequestPlan(
    requestParameters?: DeletePositionRequestPlanParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePositionRequestPlan(
    requestParameters?: DeletePositionRequestPlanParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePositionRequestPlan(
    requestParameters?: DeletePositionRequestPlanParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePositionRequestPlan(
    requestParameters?: DeletePositionRequestPlanParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePositionRequestPlan.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Deletes an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequests(
    requestParameters?: DeletePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePositionRequests(
    requestParameters?: DeletePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePositionRequests(
    requestParameters?: DeletePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePositionRequests(
    requestParameters?: DeletePositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePositionRequests.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public endJobDescriptionSession(
    requestParameters?: EndJobDescriptionSessionParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public endJobDescriptionSession(
    requestParameters?: EndJobDescriptionSessionParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public endJobDescriptionSession(
    requestParameters?: EndJobDescriptionSessionParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public endJobDescriptionSession(
    requestParameters?: EndJobDescriptionSessionParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const sessionId = requestParameters?.sessionId;
    if (sessionId === null || sessionId === undefined) {
      throw new Error('Required parameter sessionId was null or undefined when calling endJobDescriptionSession.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/job-description/sessions/${this.configuration.encodeParam({ name: 'sessionId', value: sessionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public enhanceJobDescription(
    requestParameters?: EnhanceJobDescriptionParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<GeneratedJobDescription>;
  public enhanceJobDescription(
    requestParameters?: EnhanceJobDescriptionParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<GeneratedJobDescription>>;
  public enhanceJobDescription(
    requestParameters?: EnhanceJobDescriptionParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<GeneratedJobDescription>>;
  public enhanceJobDescription(
    requestParameters?: EnhanceJobDescriptionParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const enhanceJobDescription = requestParameters?.enhanceJobDescription;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/job-description/enhancement`;
    return this.httpClient.request<GeneratedJobDescription>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: enhanceJobDescription,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Exports existing position requests by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPositionRequests(
    requestParameters?: ExportPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPositionRequests(
    requestParameters?: ExportPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionRequests(
    requestParameters?: ExportPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionRequests(
    requestParameters?: ExportPositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pendingApprovalStepName = requestParameters?.pendingApprovalStepName;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const queryType = requestParameters?.queryType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const referenceNumber = requestParameters?.referenceNumber;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const exportState = requestParameters?.exportState;
    const filename = requestParameters?.filename;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pendingApprovalStepName) {
      pendingApprovalStepName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'PendingApprovalStepName'
        );
      });
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'QueryType');
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (referenceNumber) {
      referenceNumber.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ReferenceNumber');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (exportState !== undefined && exportState !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>exportState, 'ExportState');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateJobDescription(
    requestParameters?: GenerateJobDescriptionParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<GeneratedJobDescription>;
  public generateJobDescription(
    requestParameters?: GenerateJobDescriptionParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<GeneratedJobDescription>>;
  public generateJobDescription(
    requestParameters?: GenerateJobDescriptionParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<GeneratedJobDescription>>;
  public generateJobDescription(
    requestParameters?: GenerateJobDescriptionParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const generateJobDescription = requestParameters?.generateJobDescription;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/job-description/generation`;
    return this.httpClient.request<GeneratedJobDescription>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: generateJobDescription,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets a job ad by its ID.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdJobAds(
    requestParameters?: GetByIdJobAdsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<JobAd>;
  public getByIdJobAds(
    requestParameters?: GetByIdJobAdsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<JobAd>>;
  public getByIdJobAds(
    requestParameters?: GetByIdJobAdsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<JobAd>>;
  public getByIdJobAds(
    requestParameters?: GetByIdJobAdsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getByIdJobAds.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-ads/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<JobAd>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets a job description by its ID.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdJobDescriptions(
    requestParameters?: GetByIdJobDescriptionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<JobDescription>;
  public getByIdJobDescriptions(
    requestParameters?: GetByIdJobDescriptionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<JobDescription>>;
  public getByIdJobDescriptions(
    requestParameters?: GetByIdJobDescriptionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<JobDescription>>;
  public getByIdJobDescriptions(
    requestParameters?: GetByIdJobDescriptionsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getByIdJobDescriptions.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-descriptions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<JobDescription>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets an existing position request by its id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdPositionRequests(
    requestParameters?: GetByIdPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequest>;
  public getByIdPositionRequests(
    requestParameters?: GetByIdPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequest>>;
  public getByIdPositionRequests(
    requestParameters?: GetByIdPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequest>>;
  public getByIdPositionRequests(
    requestParameters?: GetByIdPositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getByIdPositionRequests.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PositionRequest>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets the headcount approval dashboard values.
   * Values are shown in Frontend when initially opening headcount approval. They provide a quick overview of position requests the current user has access to or is involved in.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardHeadcountApproval(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalDashboard>;
  public getDashboardHeadcountApproval(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalDashboard>>;
  public getDashboardHeadcountApproval(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalDashboard>>;
  public getDashboardHeadcountApproval(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/dashboard`;
    return this.httpClient.request<HeadcountApprovalDashboard>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHiringManagersEmployeeMasterData(
    requestParameters?: GetHiringManagersEmployeeMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: GetHiringManagersEmployeeMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: GetHiringManagersEmployeeMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: GetHiringManagersEmployeeMasterDataParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/employee/hiring-managers`;
    return this.httpClient.request<PageOfEmployeesEmployeesEmployee>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: GetOrganisationHiringManagerOrganisationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesEmployeesEmployee>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: GetOrganisationHiringManagerOrganisationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesEmployeesEmployee>>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: GetOrganisationHiringManagerOrganisationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesEmployeesEmployee>>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: GetOrganisationHiringManagerOrganisationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error(
        'Required parameter orgCode was null or undefined when calling getOrganisationHiringManagerOrganisations.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/organisations/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/hiring-manager`;
    return this.httpClient.request<EmployeesEmployeesEmployee>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets a dashboard overview of counts of position request plans.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionRequestPlanDashboard(
    requestParameters?: GetPositionRequestPlanDashboardParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequestPlanDashboard>;
  public getPositionRequestPlanDashboard(
    requestParameters?: GetPositionRequestPlanDashboardParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequestPlanDashboard>>;
  public getPositionRequestPlanDashboard(
    requestParameters?: GetPositionRequestPlanDashboardParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequestPlanDashboard>>;
  public getPositionRequestPlanDashboard(
    requestParameters?: GetPositionRequestPlanDashboardParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (requestType) {
      requestType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RequestType');
      });
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (locationType) {
      locationType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LocationType');
      });
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType) {
      positionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionType');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/dashboard`;
    return this.httpClient.request<PositionRequestPlanDashboard>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets (generates) position survey data for provided query data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: GetPositionSurveyDataHeadcountApprovalParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionSurveyData>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: GetPositionSurveyDataHeadcountApprovalParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionSurveyData>>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: GetPositionSurveyDataHeadcountApprovalParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionSurveyData>>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: GetPositionSurveyDataHeadcountApprovalParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error(
        'Required parameter orgCode was null or undefined when calling getPositionSurveyDataHeadcountApproval.'
      );
    }
    const countryIsoAlpha2 = requestParameters?.countryIsoAlpha2;
    const positionClass = requestParameters?.positionClass;
    const mercerJobCodeResponse = requestParameters?.mercerJobCodeResponse;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (countryIsoAlpha2 !== undefined && countryIsoAlpha2 !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>countryIsoAlpha2,
        'CountryIsoAlpha2'
      );
    }
    if (positionClass !== undefined && positionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionClass, 'PositionClass');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/position-survey-data`;
    return this.httpClient.request<HeadcountApprovalPositionSurveyData>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: mercerJobCodeResponse,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets a dashboard overview of counts of found position requests grouped into states.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getStatesDashboardPositionRequests(
    requestParameters?: GetStatesDashboardPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Dashboard>;
  public getStatesDashboardPositionRequests(
    requestParameters?: GetStatesDashboardPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Dashboard>>;
  public getStatesDashboardPositionRequests(
    requestParameters?: GetStatesDashboardPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Dashboard>>;
  public getStatesDashboardPositionRequests(
    requestParameters?: GetStatesDashboardPositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pendingApprovalStepName = requestParameters?.pendingApprovalStepName;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const queryType = requestParameters?.queryType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const referenceNumber = requestParameters?.referenceNumber;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pendingApprovalStepName) {
      pendingApprovalStepName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'PendingApprovalStepName'
        );
      });
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'QueryType');
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (referenceNumber) {
      referenceNumber.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ReferenceNumber');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/dashboard`;
    return this.httpClient.request<Dashboard>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing business areas by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public headcountApprovalCustomerQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfCluster>;
  public headcountApprovalCustomerQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfCluster>>;
  public headcountApprovalCustomerQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfCluster>>;
  public headcountApprovalCustomerQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerQueryBusinessAreasBusinessAreasParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/business-areas`;
    return this.httpClient.request<PageOfCluster>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries position request plan business-areas of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanBusinessAreas(
    requestParameters?: PagePositionRequestPlanBusinessAreasParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfCluster>;
  public pagePositionRequestPlanBusinessAreas(
    requestParameters?: PagePositionRequestPlanBusinessAreasParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfCluster>>;
  public pagePositionRequestPlanBusinessAreas(
    requestParameters?: PagePositionRequestPlanBusinessAreasParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfCluster>>;
  public pagePositionRequestPlanBusinessAreas(
    requestParameters?: PagePositionRequestPlanBusinessAreasParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const search = requestParameters?.search;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/business-areas`;
    return this.httpClient.request<PageOfCluster>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries position request plan field values of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanFieldValues(
    requestParameters?: PagePositionRequestPlanFieldValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<FieldValues>;
  public pagePositionRequestPlanFieldValues(
    requestParameters?: PagePositionRequestPlanFieldValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<FieldValues>>;
  public pagePositionRequestPlanFieldValues(
    requestParameters?: PagePositionRequestPlanFieldValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<FieldValues>>;
  public pagePositionRequestPlanFieldValues(
    requestParameters?: PagePositionRequestPlanFieldValuesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const requestType = requestParameters?.requestType;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const targetProperty = requestParameters?.targetProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (hiringManagerGid !== undefined && hiringManagerGid !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hiringManagerGid,
        'HiringManagerGid'
      );
    }
    if (positionClass !== undefined && positionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionClass, 'PositionClass');
    }
    if (orgLevel !== undefined && orgLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgLevel, 'OrgLevel');
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (workforceType !== undefined && workforceType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workforceType, 'WorkforceType');
    }
    if (workTimeType !== undefined && workTimeType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workTimeType, 'WorkTimeType');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'targetProperty');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/field-values`;
    return this.httpClient.request<FieldValues>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing n-1 levels of a business area by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanNMinusOneLevels(
    requestParameters?: PagePositionRequestPlanNMinusOneLevelsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfClusterNode>;
  public pagePositionRequestPlanNMinusOneLevels(
    requestParameters?: PagePositionRequestPlanNMinusOneLevelsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfClusterNode>>;
  public pagePositionRequestPlanNMinusOneLevels(
    requestParameters?: PagePositionRequestPlanNMinusOneLevelsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfClusterNode>>;
  public pagePositionRequestPlanNMinusOneLevels(
    requestParameters?: PagePositionRequestPlanNMinusOneLevelsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const businessAreaId = requestParameters?.businessAreaId;
    if (businessAreaId === null || businessAreaId === undefined) {
      throw new Error(
        'Required parameter businessAreaId was null or undefined when calling pagePositionRequestPlanNMinusOneLevels.'
      );
    }
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/business-areas/${this.configuration.encodeParam({ name: 'businessAreaId', value: businessAreaId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/n-minus-one-levels`;
    return this.httpClient.request<PageOfClusterNode>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets all orgcodes and their assigned level the headcount approval process has access to.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanOrgCodes(
    requestParameters?: PagePositionRequestPlanOrgCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfHeadcountApprovalOrgCode>;
  public pagePositionRequestPlanOrgCodes(
    requestParameters?: PagePositionRequestPlanOrgCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfHeadcountApprovalOrgCode>>;
  public pagePositionRequestPlanOrgCodes(
    requestParameters?: PagePositionRequestPlanOrgCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfHeadcountApprovalOrgCode>>;
  public pagePositionRequestPlanOrgCodes(
    requestParameters?: PagePositionRequestPlanOrgCodesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/org-codes`;
    return this.httpClient.request<PageOfHeadcountApprovalOrgCode>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all available replacement employees for a planned position.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanReplacementEmployees(
    requestParameters?: PagePositionRequestPlanReplacementEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfReplacementEmployee>;
  public pagePositionRequestPlanReplacementEmployees(
    requestParameters?: PagePositionRequestPlanReplacementEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfReplacementEmployee>>;
  public pagePositionRequestPlanReplacementEmployees(
    requestParameters?: PagePositionRequestPlanReplacementEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfReplacementEmployee>>;
  public pagePositionRequestPlanReplacementEmployees(
    requestParameters?: PagePositionRequestPlanReplacementEmployeesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/replacement`;
    return this.httpClient.request<PageOfReplacementEmployee>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing position request plans of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlans(
    requestParameters?: PagePositionRequestPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfPositionRequestDraft>;
  public pagePositionRequestPlans(
    requestParameters?: PagePositionRequestPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfPositionRequestDraft>>;
  public pagePositionRequestPlans(
    requestParameters?: PagePositionRequestPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfPositionRequestDraft>>;
  public pagePositionRequestPlans(
    requestParameters?: PagePositionRequestPlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (requestType) {
      requestType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RequestType');
      });
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (locationType) {
      locationType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LocationType');
      });
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType) {
      positionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionType');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plans`;
    return this.httpClient.request<PageOfPositionRequestDraft>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries all available replacement employees.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestReplacementEmployees(
    requestParameters?: PagePositionRequestReplacementEmployeesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfReplacementEmployee>;
  public pagePositionRequestReplacementEmployees(
    requestParameters?: PagePositionRequestReplacementEmployeesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfReplacementEmployee>>;
  public pagePositionRequestReplacementEmployees(
    requestParameters?: PagePositionRequestReplacementEmployeesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfReplacementEmployee>>;
  public pagePositionRequestReplacementEmployees(
    requestParameters?: PagePositionRequestReplacementEmployeesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/replacement`;
    return this.httpClient.request<PageOfReplacementEmployee>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing n-1 levels of a business area areas by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: QueryBusinessAreaNMinusOneLevelsBusinessAreasParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfClusterNode>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: QueryBusinessAreaNMinusOneLevelsBusinessAreasParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfClusterNode>>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: QueryBusinessAreaNMinusOneLevelsBusinessAreasParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfClusterNode>>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: QueryBusinessAreaNMinusOneLevelsBusinessAreasParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const businessAreaId = requestParameters?.businessAreaId;
    if (businessAreaId === null || businessAreaId === undefined) {
      throw new Error(
        'Required parameter businessAreaId was null or undefined when calling queryBusinessAreaNMinusOneLevelsBusinessAreas.'
      );
    }
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/business-areas/${this.configuration.encodeParam({ name: 'businessAreaId', value: businessAreaId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/n-minus-one-levels`;
    return this.httpClient.request<PageOfClusterNode>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: QueryEmployeeMasterDataEmployeeMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<ReferenceEmployee>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: QueryEmployeeMasterDataEmployeeMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<ReferenceEmployee>>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: QueryEmployeeMasterDataEmployeeMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<ReferenceEmployee>>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: QueryEmployeeMasterDataEmployeeMasterDataParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling queryEmployeeMasterDataEmployeeMasterData.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<ReferenceEmployee>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries position request field values by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesPositionRequests(
    requestParameters?: QueryFieldValuesPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<FieldValues>;
  public queryFieldValuesPositionRequests(
    requestParameters?: QueryFieldValuesPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<FieldValues>>;
  public queryFieldValuesPositionRequests(
    requestParameters?: QueryFieldValuesPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<FieldValues>>;
  public queryFieldValuesPositionRequests(
    requestParameters?: QueryFieldValuesPositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error(
        'Required parameter targetProperty was null or undefined when calling queryFieldValuesPositionRequests.'
      );
    }
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const pendingApprovalStepName = requestParameters?.pendingApprovalStepName;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgCode = requestParameters?.orgCode;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const queryType = requestParameters?.queryType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const referenceNumber = requestParameters?.referenceNumber;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (pendingApprovalStepName !== undefined && pendingApprovalStepName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>pendingApprovalStepName,
        'PendingApprovalStepName'
      );
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (countryGeoClusterNodeId !== undefined && countryGeoClusterNodeId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>countryGeoClusterNodeId,
        'CountryGeoClusterNodeId'
      );
    }
    if (nMinusOneLevelClusterNodeId !== undefined && nMinusOneLevelClusterNodeId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>nMinusOneLevelClusterNodeId,
        'NMinusOneLevelClusterNodeId'
      );
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (hiringManagerGid !== undefined && hiringManagerGid !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hiringManagerGid,
        'HiringManagerGid'
      );
    }
    if (positionClass !== undefined && positionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionClass, 'PositionClass');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (orgLevel !== undefined && orgLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgLevel, 'OrgLevel');
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'QueryType');
    }
    if (workforceType !== undefined && workforceType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workforceType, 'WorkforceType');
    }
    if (workTimeType !== undefined && workTimeType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workTimeType, 'WorkTimeType');
    }
    if (referenceNumber !== undefined && referenceNumber !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>referenceNumber, 'ReferenceNumber');
    }
    if (areCode !== undefined && areCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areCode, 'AreCode');
    }
    if (depthStructure !== undefined && depthStructure !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>depthStructure, 'DepthStructure');
    }
    if (costCenter !== undefined && costCenter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>costCenter, 'CostCenter');
    }
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (region !== undefined && region !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>region, 'Region');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/field-values`;
    return this.httpClient.request<FieldValues>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Query job descriptions and job ads based on input
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryJobDescriptions(
    requestParameters?: QueryJobDescriptionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfMinimalJobDescription>;
  public queryJobDescriptions(
    requestParameters?: QueryJobDescriptionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfMinimalJobDescription>>;
  public queryJobDescriptions(
    requestParameters?: QueryJobDescriptionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfMinimalJobDescription>>;
  public queryJobDescriptions(
    requestParameters?: QueryJobDescriptionsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error('Required parameter orgCode was null or undefined when calling queryJobDescriptions.');
    }
    const jobCodeId = requestParameters?.jobCodeId;
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (jobCodeId !== undefined && jobCodeId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCodeId, 'JobCodeId');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-descriptions`;
    return this.httpClient.request<PageOfMinimalJobDescription>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all orgcodes and their assigned level the headcount approval process has access to.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryOrgCodesHeadcountApproval(
    requestParameters?: QueryOrgCodesHeadcountApprovalParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfHeadcountApprovalOrgCode>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: QueryOrgCodesHeadcountApprovalParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfHeadcountApprovalOrgCode>>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: QueryOrgCodesHeadcountApprovalParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfHeadcountApprovalOrgCode>>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: QueryOrgCodesHeadcountApprovalParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/org-codes`;
    return this.httpClient.request<PageOfHeadcountApprovalOrgCode>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all comments of an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPositionRequestComments(
    requestParameters?: QueryPositionRequestCommentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<CommentModel>>;
  public queryPositionRequestComments(
    requestParameters?: QueryPositionRequestCommentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<CommentModel>>>;
  public queryPositionRequestComments(
    requestParameters?: QueryPositionRequestCommentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<CommentModel>>>;
  public queryPositionRequestComments(
    requestParameters?: QueryPositionRequestCommentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    if (positionRequestId === null || positionRequestId === undefined) {
      throw new Error(
        'Required parameter positionRequestId was null or undefined when calling queryPositionRequestComments.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`;
    return this.httpClient.request<Array<CommentModel>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing position requests by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPositionRequests(
    requestParameters?: QueryPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfPositionRequest>;
  public queryPositionRequests(
    requestParameters?: QueryPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfPositionRequest>>;
  public queryPositionRequests(
    requestParameters?: QueryPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfPositionRequest>>;
  public queryPositionRequests(
    requestParameters?: QueryPositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pendingApprovalStepName = requestParameters?.pendingApprovalStepName;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const queryType = requestParameters?.queryType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const referenceNumber = requestParameters?.referenceNumber;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pendingApprovalStepName) {
      pendingApprovalStepName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'PendingApprovalStepName'
        );
      });
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'QueryType');
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (referenceNumber) {
      referenceNumber.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ReferenceNumber');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests`;
    return this.httpClient.request<PageOfPositionRequest>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: QueryReferenceEmployeesEmployeeMasterDataParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<ReferenceEmployee>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: QueryReferenceEmployeesEmployeeMasterDataParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<ReferenceEmployee>>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: QueryReferenceEmployeesEmployeeMasterDataParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<ReferenceEmployee>>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: QueryReferenceEmployeesEmployeeMasterDataParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error(
        'Required parameter orgCode was null or undefined when calling queryReferenceEmployeesEmployeeMasterData.'
      );
    }
    const search = requestParameters?.search;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/employee/reference/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<ReferenceEmployee>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing countries of a region by specified parameters. Can also query all countries if no region is supplied.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRegionCountriesCountries(
    requestParameters?: QueryRegionCountriesCountriesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfCountryClusterNode>;
  public queryRegionCountriesCountries(
    requestParameters?: QueryRegionCountriesCountriesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfCountryClusterNode>>;
  public queryRegionCountriesCountries(
    requestParameters?: QueryRegionCountriesCountriesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfCountryClusterNode>>;
  public queryRegionCountriesCountries(
    requestParameters?: QueryRegionCountriesCountriesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const regionIds = requestParameters?.regionIds;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (regionIds) {
      regionIds.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RegionIds');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/countries`;
    return this.httpClient.request<PageOfCountryClusterNode>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing regions by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRegionsRegions(
    requestParameters?: QueryRegionsRegionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfCluster>;
  public queryRegionsRegions(
    requestParameters?: QueryRegionsRegionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfCluster>>;
  public queryRegionsRegions(
    requestParameters?: QueryRegionsRegionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfCluster>>;
  public queryRegionsRegions(
    requestParameters?: QueryRegionsRegionsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/regions`;
    return this.httpClient.request<PageOfCluster>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Transfers an existing position request to a new organization.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public transferPositionRequest(
    requestParameters?: TransferPositionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequest>;
  public transferPositionRequest(
    requestParameters?: TransferPositionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequest>>;
  public transferPositionRequest(
    requestParameters?: TransferPositionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequest>>;
  public transferPositionRequest(
    requestParameters?: TransferPositionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling transferPositionRequest.');
    }
    const transferPositionRequest = requestParameters?.transferPositionRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/transfer`;
    return this.httpClient.request<PositionRequest>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: transferPositionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Updates an existing job description.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateJobDescriptions(
    requestParameters?: UpdateJobDescriptionsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<JobDescription>;
  public updateJobDescriptions(
    requestParameters?: UpdateJobDescriptionsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<JobDescription>>;
  public updateJobDescriptions(
    requestParameters?: UpdateJobDescriptionsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<JobDescription>>;
  public updateJobDescriptions(
    requestParameters?: UpdateJobDescriptionsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateJobDescriptions.');
    }
    const updateJobDescription = requestParameters?.updateJobDescription;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-descriptions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<JobDescription>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateJobDescription,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Updates an existing position request draft by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequestDrafts(
    requestParameters?: UpdatePositionRequestDraftsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequestDraft>;
  public updatePositionRequestDrafts(
    requestParameters?: UpdatePositionRequestDraftsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequestDraft>>;
  public updatePositionRequestDrafts(
    requestParameters?: UpdatePositionRequestDraftsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequestDraft>>;
  public updatePositionRequestDrafts(
    requestParameters?: UpdatePositionRequestDraftsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePositionRequestDrafts.');
    }
    const updatePositionRequestDraft = requestParameters?.updatePositionRequestDraft;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/drafts/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PositionRequestDraft>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updatePositionRequestDraft,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Updates an existing position request plan by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequestPlan(
    requestParameters?: UpdatePositionRequestPlanParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequestDraft>;
  public updatePositionRequestPlan(
    requestParameters?: UpdatePositionRequestPlanParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequestDraft>>;
  public updatePositionRequestPlan(
    requestParameters?: UpdatePositionRequestPlanParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequestDraft>>;
  public updatePositionRequestPlan(
    requestParameters?: UpdatePositionRequestPlanParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePositionRequestPlan.');
    }
    const updatePositionRequestPlan = requestParameters?.updatePositionRequestPlan;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PositionRequestDraft>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updatePositionRequestPlan,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates a new position request (as a \&#39;create from draft by its unique id\&#39;) or updates an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequests(
    requestParameters?: UpdatePositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequest>;
  public updatePositionRequests(
    requestParameters?: UpdatePositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequest>>;
  public updatePositionRequests(
    requestParameters?: UpdatePositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequest>>;
  public updatePositionRequests(
    requestParameters?: UpdatePositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePositionRequests.');
    }
    const updatePositionRequest = requestParameters?.updatePositionRequest;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PositionRequest>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updatePositionRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Vetos an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public vetoPositionRequests(
    requestParameters?: VetoPositionRequestsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PositionRequest>;
  public vetoPositionRequests(
    requestParameters?: VetoPositionRequestsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PositionRequest>>;
  public vetoPositionRequests(
    requestParameters?: VetoPositionRequestsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PositionRequest>>;
  public vetoPositionRequests(
    requestParameters?: VetoPositionRequestsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling vetoPositionRequests.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/veto`;
    return this.httpClient.request<PositionRequest>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }
}
